export default __webpack_public_path__ + "images/13c8d01d7167a40deafaaa8cbde194bf-crowd-illustration.svg";